export default {
      id: "sensors__mileage-usage",
      viewBox: "0 0 38 22",
      url: __webpack_public_path__ + "img/icons.svg#sensors__mileage",
      toString: function () {
        return this.url;
      }
    }